import React from 'react'
import { Outlet } from 'react-router-dom'
import ProfileNavBar from '../../Component/ProfileNavbar'

const Layout = () => {
    return (
        <div className='dashboard'>
            <div className='d-flex w-100'>
                <ProfileNavBar />
                <div className='dashRightView'>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Layout